import { Skeleton } from "@spz/ui/components/skeleton";
import { TruncatedText } from "@spz/ui/components/truncated-text";
import { interval } from "@spz/ui/lib/utils";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface ResultValuesProps {
  data?: { key: string; value: string | number }[];
  isLoading?: boolean;
}

const SKELETON_ELEMENTS_COUNT = 6; // Number of skeleton elements to show when loading

const ResultValues: FC<ResultValuesProps> = ({
  isLoading,
  data,
}: ResultValuesProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap flex-grow gap-4 items-center">
      {isLoading
        ? interval(SKELETON_ELEMENTS_COUNT).map((num) => (
            <div
              key={`skeleton-element-${num}`}
              className="w-1/6 h-7 flex items-center"
            >
              <Skeleton
                className="h-3 w-[70px] mx-4"
                aria-label="Loading stats"
              />
            </div>
          ))
        : data?.map((item) => (
            <div key={item.key} className="w-1/6 min-h-7 max-h-11">
              {t(item.key)}:
              <TruncatedText maxLines={2}>
                <strong>{item.value}</strong>
              </TruncatedText>
            </div>
          ))}
    </div>
  );
};

export default ResultValues;
